import React from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { format } from "date-fns";
import "./profile-referral.scss";

import { Text, Icon } from "@ui-kit";
import { getCustomer } from "@entities";
import CopyIcon from '@ui-kit/icons/copy-gray600.svg';

const ProfilePassword = () => {
  const user = useSelector(getCustomer);
  const {
    referralCode,
    freePeriodFrom = 0,
    freePeriodTo = 0,
  } = user;

  const referralSrc = `https://keyhunter.net?referral=${referralCode}`

  const copyReferral = () => {
    return navigator.clipboard.writeText(referralCode)
  }

  const copySrc = () => {
    return navigator.clipboard.writeText(referralSrc)
  }

  const renderPeriod = () => {
    if (!+freePeriodTo) return;

    return (
      <Text as="h5">
        Free period:{" "}
        {`
          ${format(new Date(freePeriodFrom), "dd.MM.yyyy HH:mm")} - 
          ${format(new Date(freePeriodTo), "dd.MM.yyyy HH:mm")}
        `}
      </Text>
    );
  };

  const renderCode = () => {
    if (referralCode) {
      return (
        <div className="code__copy d-flex jc-center" onClick={copyReferral}>
          <Text as="h3">{referralCode}</Text>
          <div className="code__img">
            <Icon src={CopyIcon} className="code"/>
          </div>
        </div>
      )
    }

    return (
      <Text as="h3">First, pay for your Patreon subscription.</Text>
    )
  }

  const renderSrc = () => {
    if (referralCode) {
      return (
        <div className="code__copy d-flex jc-center" onClick={copySrc}>
          <Text as="h6">{referralSrc}</Text>
          <div className="code__img">
            <Icon src={CopyIcon} />
          </div>
        </div>
      )
    }

    return
  }

  return (
    <div className="profile__referral">
      <div className="profile__referral-header">
        <Text as="h2" className="title">
          <FormattedMessage
            id="profile.referral.title"
            defaultMessage="Referral program"
          />
        </Text>
        <Text as="h5" className="sub-title">
          <FormattedMessage
            id="profile.referral.description1"
            defaultMessage="To be able to use the referral program and receive a code, you must pay for a subscription to Patreon."
          />
        </Text>
        <Text as="h5" className="sub-title">
          <FormattedMessage
            id="profile.referral.description2"
            defaultMessage="For each invited person you get 30 free days, provided that the invited person pays for a subscription to Patreon."
          />
        </Text>
        <Text as="h5" className="sub-title">
          <FormattedMessage
            id="profile.referral.description3"
            defaultMessage="The number of invitations is not limited."
          />
        </Text>
      </div>
      <div className="profile__referral-container">
        <Text as="h5">
          <FormattedMessage
            id="profile.referral.code"
            defaultMessage="Your personal referral code:"
          />
        </Text>
        {renderCode()}
        {renderSrc()}
        {renderPeriod()}
      </div>
    </div>
  );
};

export default ProfilePassword;
